document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('product-model.zoom_wrapper');
  const closeBtn = document.getElementById('ModalClose');

  document.querySelectorAll('.main_image_inner').forEach((el, index) => {
    el.addEventListener('click', () => {
      modal.classList.add('active');
      document.body.classList.add('overflow-hidden');
      setTimeout(() => {
        initModalSwiper();
        initZoomInsideModal();
        // modalSwiper.slideTo(index);
      }, 300);
    });
  });

  closeBtn?.addEventListener('click', () => {
    modal.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  });
});

let modalSwiper;
let thumbSwiper;

function initModalSwiper() {
  if (modalSwiper && thumbSwiper) return;

 thumbSwiper = new Swiper('.custom_thumbnail_slider', {
  slidesPerView: 7,
  spaceBetween: 10,
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.thumb-next',
    prevEl: '.thumb-prev',
  },
  breakpoints: {
    0: {
      slidesPerView: 5
    },
    768: {
      slidesPerView: 7
    }
  }
});

  modalSwiper = new Swiper('.main_image_popup_slider', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.main-next',
      prevEl: '.main-prev',
    },
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    // },
    thumbs: {
      swiper: thumbSwiper,
    },
  });
}

// function initZoomInsideModal() {
//   const zoomEls = document.querySelectorAll('.main_image_popup_slider img');
//   zoomEls.forEach(img => {
//     const panzoom = Panzoom(img, {
//       maxZoom: 4,
//       minZoom: 1,
//       contain: 'outside'
//     });
//     img._panzoom = panzoom;
//     img.parentElement.addEventListener('wheel', panzoom.zoomWithWheel);
//   });
// }